'use strict';

module.exports = Object.getOwnPropertyNames;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/object/var/getOwnPropertyNames.js
// module id = 261
// module chunks = 0